import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import config from 'config'
import { Common, C02ProductParameter } from '@/js/common.js'
import { Logger } from '@/js/utils/Logger.js';

class APIConnect {
    /**
     * パートナー情報取得
     */
    static A01() {
        Logger.info("A01開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken
                }
                //var parameter = new URLSearchParams();
                var parameter = new FormData()
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/detail.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー情報更新
     */
    static A02(params) {
        Logger.info("A02開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    ...params
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/edit.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(response.data.errors)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー情報取得
     */
    static A03(code) {
        Logger.info("A03開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    introduced_from: code
                }
                // var parameter = new URLSearchParams();
                var parameter = new FormData()

                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/code.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー 契約書の署名依頼の送信
     */
    static A04(userData) {
        Logger.info("A04開始")
        console.log(userData)
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    is_individual: userData.is_individual,
                    name01: userData.name01,
                    name02: userData.name02,
                    kana01: userData.kana01,
                    kana02: userData.kana02,
                    zip01: userData.zip01,
                    zip02: userData.zip02,
                    pref: userData.pref,
                    addr01: userData.addr01,
                    addr02: userData.addr02,
                    company_name: userData.company_name,
                    representative_name: userData.representative_name,
                    tel01: userData.tel01,
                    tel02: userData.tel02,
                    tel03: userData.tel03,
                    email: userData.email,
                }
                var parameter = new FormData()

                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/send_request.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー 契約書の署名状態を確認
     */
    static A05(xid) {
        Logger.info("A05開始")
        Logger.debug(xid)
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    contract_xid: xid,
                }
                // var parameter = new URLSearchParams();
                var parameter = new FormData()

                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/check_signature.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー 契約書を再送信
     */
    static A06(xid) {
        Logger.info("A06開始")
        Logger.debug(xid)
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    envelope_xid: xid,
                }
                // var parameter = new URLSearchParams();
                var parameter = new FormData()

                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/resend_request.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー アカウント認証用のメールを送信
     */
    static A07(email) {
        Logger.info("A07開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    email: email,
                    site_type: 3,
                }
                // var parameter = new URLSearchParams();
                var parameter = new FormData()

                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/send_verification_email.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー パスワード変更用のメールを送信
     */
    static A08(email) {
        Logger.info("A08開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    email: email,
                    site_type: 3,
                }
                // var parameter = new URLSearchParams();
                var parameter = new FormData()

                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/partner/send_password_reset_email.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * パートナー情報配送先取得
     */
    static B01() {
        Logger.info("B01開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/deliv/list.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData['deliv_list'])
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * パートナー情報登録
     */
    static B02(params) {
        Logger.info("B02開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    ...params,
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                Common.log(...parameter.entries());   
                
                axios.post("/api/v1/deliv/edit.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        Common.log(resData)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * 配送先削除
     */
    static B03(params) {
        Logger.info("B03開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                let param = {
                    token: idtoken,
                    ...params,
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                Common.log(...parameter.entries());   
                
                axios.post("/api/v1/deliv/delete.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        Common.log(resData)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * 注文履歴一覧取得
     * @param {パラメータの連想配列} para 
     */
    static C01(para) {
        Logger.info("C01開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    except_detail: true,
                    buy_site: 3,
                    ...para
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/order/history.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData['order_list'])
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * 注文
     * @param {パラメータの連想配列} para 
     */
    static C02(productList, otherData, paymentType) {
        Logger.info("C02開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...otherData,
                    payment_id:paymentType,
                    buy_site_type:3,
                }
                var parameter = new FormData();
                for (let key in param) {
                    parameter.append(key, param[key])
                }

                var cnt = 0
                productList.forEach(pdata => {
                    for (let name in C02ProductParameter) {
                        parameter.append(`product_list[${cnt}][${C02ProductParameter[name]}]`, pdata[C02ProductParameter[name]])
                    }
                    cnt += 1
                });


                Common.log(...parameter.entries());
                axios.post("/api/v1/order/regist.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * 領収書ダウンロード
     * @param {注文ID} orderId
     */
    static C03(orderId) {
        Logger.info("C03開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    order_id:orderId,
                    payment_id:10
                }
                var parameter = new FormData();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                console.log("C03準備")
                axios.post("/api/v1/order/invoice.php", parameter,{
                    responseType:'blob',
                    dataType:'binary',
                })
                    .then((response) => {
                        console.log("C03結果")

                        let url = URL.createObjectURL(response.data)

                        const a = document.createElement("a");
                        document.body.appendChild(a);
                        a.download = 'invoice.pdf';
                        a.href = url;
                        a.click();
                        a.remove();
                        URL.revokeObjectURL(url);

                        resolve()
                    })
                    .catch((e) => {
                        console.log("C03異常終了")
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                console.log("C03異常終了")
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * 注文確定
     * @param {パラメータの連想配列} para 
     */
    static C05(orderId) {
        Logger.info("C05開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    order_id:orderId,
                }
                var parameter = new FormData();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/order/complete.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * クーポン注文
     * @param {パラメータの連想配列} para 
     */
    static C07(productList, otherData, paymentType) {
        Logger.info("C07開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...otherData,
                    payment_id:paymentType,
                    buy_site_type:3,
                }
                var parameter = new FormData();
                for (let key in param) {
                    parameter.append(key, param[key])
                }

                var cnt = 0
                productList.forEach(pdata => {
                    for (let name in C02ProductParameter) {
                        parameter.append(`product_list[${cnt}][${C02ProductParameter[name]}]`, pdata[C02ProductParameter[name]])
                    }
                    cnt += 1
                });

                Common.log(...parameter.entries());
                axios.post("/api/v1/pro/acrylic_coupon_order.php", parameter)
                    .then((response) => {
                        Logger.info(response)
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * 受注状態確認
     * @param {パラメータの連想配列} para 
     */
    static C08(orderId) {
        Logger.info("C08開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    order_id: orderId
                }
                var parameter = new FormData();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/order/status.php", parameter)
                    .then((response) => {
                        Logger.info(response)
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * エージェント情報取得
     */
    static D01() {
        Logger.info("D01開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/agent/detail.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * エージェント情報登録
     */
    static D02(params) {
        Logger.info("D02開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...params
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/agent/edit.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(response.data.errors)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * エージェント情報認証
     */
    static D03(code) {
        Logger.info("D03開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    agent_code: code
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/agent/code.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * エージェント パートナー一覧取得
     */
    static D04(para) {
        Logger.info("D04開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...para
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/agent/partner.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData.partner_list)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * エージェント パートナー一覧取得
     */
    static D05(para) {
        Logger.info("D05開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                }
                var parameter = new FormData();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                var cnt = 0
                para.forEach(pdata => {
                    parameter.append(`partner_list[${cnt}][customer_id]`, pdata['customer_id'])
                    parameter.append(`partner_list[${cnt}][introduced_margin]`, pdata['introduced_margin'])
                    parameter.append(`partner_list[${cnt}][approval_status]`, pdata['approval_status'])
                    cnt += 1
                });

                axios.post("/api/v1/agent/partner_edit.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * エージェント パートナー売り上げ一覧取得
     */
    static D06(para) {
        Logger.info("D06開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...para
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/agent/sales.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData.sales_list)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * エージェント 支払い履歴
     */
    static D07(para) {
        Logger.info("D07開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...para
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/agent/payment.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            resolve(resData.payment_list)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }
    /**
     * 商品企画取得
     */
    static E01(para) {
        Logger.info("E01開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                    ...para
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/product/class.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            console.log(resData)
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * AcryProオプション品一覧
     */
    static E02() {
        Logger.info("E02開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                }
                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/product/get_acrypro_options.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            console.log(resData)
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    /**
     * 商品企画取得
     */
    static E05(ids) {
        Logger.info("E05開始")
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idtoken) {
                var param = {
                    token: idtoken,
                }

                var cnt = 0
                ids.forEach(id => {
                    param[`product_ids[${cnt}]`] = id;
                    cnt += 1
                });

                var parameter = new URLSearchParams();
                for (let key in param) {
                    parameter.append(key, param[key])
                }
                axios.post("/api/v1/product/classes.php", parameter)
                    .then((response) => {
                        let resData = APIConnect.errorCheck(response)
                        if (resData !== 0) {
                            console.log(resData)
                            resolve(resData)
                        } else {
                            reject(0)
                        }
                    })
                    .catch((e) => {
                        Common.log(e);
                        reject(0)
                    });
            }).catch(function (error) {
                Common.log(error)
                reject(0)
            })
        })
    }

    static buildUrl(path) {
        let url = path + config.testSuffix
        Common.log(url)
        return url
    }
    static errorCheck(data) {
        if (data['data']['status'] == "200") {
            return data['data']['response']
        } else {
            Logger.error("失敗")
            Logger.error(data)
            return 0
        }
    }
}
export { APIConnect }
